import { useState, useEffect } from 'react';
import { fetchMostActiveStocks, fetchGainersLosers, fetchYearlyHigh, fetchYearlyLow } from '../../../../../services/backendAPI';

export const useStockDiscoveryData = () => {
  const [mostActive, setMostActive] = useState([]);
  const [movers, setMovers] = useState({ gainers: [], losers: [] });
  const [yearlyHigh, setYearlyHigh] = useState([]);
  const [yearlyLow, setYearlyLow] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const [activeRes, moversRes, highRes, lowRes] = await Promise.all([
          fetchMostActiveStocks('NSE', ''),
          fetchGainersLosers('NSE', ''),
          fetchYearlyHigh('NSE', ''),
          fetchYearlyLow('NSE', '')
        ]);

        if (activeRes?.data) {
          setMostActive(activeRes.data.most_active_volume || activeRes.data.most_active_value || []);
        }
        if (moversRes?.data) setMovers({
            gainers: moversRes.data.gainers || [],
            losers: moversRes.data.losers || []
        });
        if (highRes?.status === "success" || highRes?.data) {
          setYearlyHigh(highRes.data || highRes.result || []);
        }
        if (lowRes?.status === "success" || lowRes?.data) {
          setYearlyLow(lowRes.data || lowRes.result || []);
        }
      } catch (error) {
        console.error("Error loading Stock Discovery data:", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  return { mostActive, movers, yearlyHigh, yearlyLow, loading };
};
